module.exports = __webpack_public_path__ + "7e096275e91cf26b0f4cca93e6b32159.svg";